import {
  FETCH_WEATHERFORECAST_FAILURE,
  FETCH_WEATHERFORECAST_REQUEST,
  FETCH_WEATHERFORECAST_SUCCESS,
} from "../actions/weatherForecast.actions";

const initialState = {
  data: [],
  loading: false,
};

const weatherForecast = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WEATHERFORECAST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WEATHERFORECAST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_WEATHERFORECAST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default weatherForecast;
